import { useEffect } from 'react';

const FaviconLoader = () => {
	useEffect(() => {
		const favicon = document.getElementById('favicon');
		if (favicon && process.env.REACT_APP_FAVICON) {
			favicon.href = process.env.REACT_APP_FAVICON;
		}
	}, []);

	return null;
};

export default FaviconLoader;
